/**
 * @generated SignedSource<<94c02a5eeed043c9858d7e1d928a6603>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NudgeContributorFilter_contentContributors$data = {
  readonly isCurrentUserContributor: boolean | null;
  readonly " $fragmentType": "NudgeContributorFilter_contentContributors";
};
export type NudgeContributorFilter_contentContributors$key = {
  readonly " $data"?: NudgeContributorFilter_contentContributors$data;
  readonly " $fragmentSpreads": FragmentRefs<"NudgeContributorFilter_contentContributors">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NudgeContributorFilter_contentContributors",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    }
  ],
  "type": "ContentContributors"
};

(node as any).hash = "e56eaa011a9f1f6337981eb2eab39997";

export default node;
